// import exception monitoring first
import "views_shared/app/javascript/scripts/sentry";

// load our own libraries
import "views_shared/app/javascript/scripts/views_shared";

// setup supabase.js client for API calls
import "views_shared/app/javascript/scripts/supabase_client";

// https://jeremydye.fyi/2022/01/15/rails-7-and-react-install-guide/
// https://blog.dennisokeeffe.com/blog/2022-02-19-rails-7-using-react-with-esbuild?utm_campaign=Den%20Dribbles%20Weekly%20Newletter&utm_medium=email&utm_source=Revue%20newsletter
const ReactRailsUJS = require("react_ujs");

// https://github.com/reactjs/react-rails/issues/1149#issue-1053575397
/* eslint-disable global-require, react-hooks/rules-of-hooks */
// Looked up by key through a require.context-shaped function: react_ujs's eval fallback
// only ever worked on unminified bundles, where esbuild hoisted each component by name.
const components = {
  AdminUserActivity: require("./components/admin_users/AdminUserActivity"),
  AdminUserFollowing: require("./components/admin_users/AdminUserFollowing"),
  AdminUserHeader: require("./components/admin_users/AdminUserHeader"),
  AvatarWithLabel: require("views_shared/app/javascript/components/AvatarWithLabel"),
  AdminUserNotifications: require("./components/admin_users/AdminUserNotifications"),
  AdminUserOverview: require("./components/admin_users/AdminUserOverview"),
  AdminUserProfiles: require("./components/admin_users/AdminUserProfiles"),
  AdminUserTrust: require("./components/admin_users/AdminUserTrust"),
  AgencyAnalytics: require("./components/agency_analytics/AgencyAnalytics"),
  ContextualPanel: require("./components/contextual_panel/ContextualPanel"),
  FeedPostsAdminPanel: require("./components/feed_posts/FeedPostsAdminPanel"),
  MarketingPersonasIndex: require("./components/marketing_personas/MarketingPersonasIndex"),
  MediaOutletShow: require("./components/media_outlets/MediaOutletShow"),
  MediaOutletsIndex: require("./components/media_outlets/MediaOutletsIndex"),
  MergeConsole: require("./components/merge_console/MergeConsole"),
  ModerationHubPanel: require("./components/moderation/ModerationHubPanel"),
  NewUsersAdminPanel: require("./components/new_users/NewUsersAdminPanel"),
  PromoterAnalytics: require("./components/promoter_analytics/PromoterAnalytics"),
  RequestShow: require("./components/requests/RequestShow"),
  RequestsAdminPanel: require("./components/requests/RequestsAdminPanel"),
  QwotedTopHundred: require("./components/qwoted_top_hundred/QwotedTopHundred"),
  QwotedTopHundreds: require("./components/qwoted_top_hundred/QwotedTopHundreds"),
  QwotedAgencyFifty: require("./components/qwoted_agency_fifty/QwotedAgencyFifty"),
  QwotedAgencyFifties: require("./components/qwoted_agency_fifty/QwotedAgencyFifties"),
  SendgridSuppressionCard: require("./components/sendgrid_suppressions/SendgridSuppressionCard"),
  SimilaritySearchConsole: require("./components/similarity_search_console/SimilaritySearchConsole"),
  StoryIdeaFormPage: require("./components/story_ideas/form/StoryIdeaFormPage"),
  StoryIdeasIndex: require("./components/story_ideas/StoryIdeasIndex"),
  Users: require("./components/admin_users/AdminUserProfiles"),
};
ReactRailsUJS.useContext((path) => {
  const component = components[path.replace(/^\.\//, "")];
  if (!component) throw new Error(`Unknown React component: ${path}`);
  return component;
});
